"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConversationLastMessageByEnum = void 0;
var ConversationLastMessageByEnum;
(function (ConversationLastMessageByEnum) {
    ConversationLastMessageByEnum["Contact"] = "Contact";
    ConversationLastMessageByEnum["Agent"] = "Agent";
})(ConversationLastMessageByEnum = exports.ConversationLastMessageByEnum || (exports.ConversationLastMessageByEnum = {}));
